import * as Sentry from '@sentry/browser';
import {Dedupe} from '@sentry/integrations/esm/dedupe';

export const U = {
 L: (function(){
  const ll = {
   trace: {c:'debug',s:10},
   debug: {c:'debug',s:20},
   info:  {c:'log',s:30,r:'info'},
   warn:  {c:'warn',s:40,r:'warning'},
   error: {c:'error',s:50},
   fatal: {c:'error',s:60}
  };
  return Object.keys(ll).reduce(function(p,c) {
   const li = ll[c], _console = console, _consoler = console[li.c];
   p[c] = function L_dolog(d,m) {
    const reported = d && d._reported;
    if(reported) delete d._reported;
    if(m===undefined)
     m=d,d=undefined,_consoler.call(_console,m);
    else
     _consoler.call(_console,m,d);
    if(U.REPORT && !reported) {
     if(li.s>=40) U.REPORT.message(m,li.r||c,d);
     else U.REPORT.crumb(m,d,c);
    }
   };
   return p;
  },{});
 })(),
 REPORT: (function(){
  const dsn = WTGCONFIG.sentry && WTGCONFIG.sentry.DSN;
  const pathlevel = function(n) {
   return n.tagName.toLowerCase() + (n.id && '#'+n.id)||((''+n.classList)&&('.'+n.classList).replace(/ /g,'.'));
  };
  const pather = function(n) {
   return n.parentNode? pather(n.parentNode).concat(pathlevel(n)):[];
  };
  if(dsn) {
   const io = {
    dsn: dsn,
    beforeBreadcrumb: function(breadcrumb/*, hint*/) {
     if(breadcrumb.data && breadcrumb.data.extra && breadcrumb.data.extra.arguments instanceof Array)
      breadcrumb.data.extra.arguments = breadcrumb.data.extra.arguments.map(function(x) {
       return (x instanceof Node || x instanceof HTMLElement || x instanceof Element)?pather(x).join('>'):x;
      });
     return breadcrumb;
    },
    beforeSend: function(e,h) {
     if(e && e.stacktrace) {
      const dli = e.stacktrace.frames.findIndex(function(x) {
       return x.function.indexOf('L_dolog')>=0;
      });
      if(dli>=0) for(var i=e.stacktrace.frames.length-1;i>=dli;--i)
       e.stacktrace.frames[i].in_app = false;
     }
     try {
      const fp = [];
      if(e.message) fp.push(e.message);
      if(h.originalException) {
       if(h.originalException.message)
	fp.push(h.originalException.message);
       else if('string' == typeof h.originalException)
	fp.push(h.originalException);
      }
      if(h.syntheticException) {
       if(h.syntheticException.message)
	fp.push(h.syntheticException.message);
       else if('string' == typeof h.syntheticException)
	fp.push(h.syntheticException);
      }
      if(e.stacktrace) fp.push(
       e.stacktrace.frames.filter(function(x){return x.in_app}).map(function(x) {
	return x.filename.split('/').pop()+
         /*+':'+x.lineno+':'+x.colno+*/
         ' '+(x['function']||'').split('.').pop();
       }).slice(0,3).join(';') /* TODO: cut off stack trace more intelligently */
      );
      while(fp.length>1 && fp[0]==fp[1]) fp.shift();
      if(fp.length) e.fingerprint = fp;
     }catch(ee){
      console.error(ee);
     }
     return e;
    },
    attachStacktrace: true,
    integrations: function(i) {
     i.push(new Dedupe());
     return i;
    }
   };
   const r = WTGCONFIG._META.REV;
   if(r) io.release = r;
   const env = WTGCONFIG._META.ENV;
   if(env) io.environment = env;
    // TODO: io.serverName
   Sentry.init(io);
  }
  const rv = {
   exception: function(e,extra) {
    if(dsn) Sentry.captureException(e,extra);
    const d = {err:e,_reported:!!dsn};
    if(extra!==undefined) d.extra=extra;
    L.error(d);
   },
   message: function(m,level,extra) {
    if(dsn) Sentry.withScope( function(s) {
     if(extra!==undefined) s.setExtra('extra',extra);
     Sentry.captureMessage(m,level);
    });
   },
   crumb: function(m,data,level) {
    if(dsn) Sentry.addBreadcrumb({
     message: m,
     data: data,
     level: level
    });
   },
   user: function(u) {
    if(dsn) Sentry.configureScope(function(s) {
     s.setUser(u);
    });
   }
  };
  rv.message('pageload','info');
  return rv;
 })(),

 browser: (function browserinfo() {
  const browsers = [
   {re:/\b(MSIE)\/([\d.]+)/,bn:1,bv:2},
   {re:/\b(Chrome)\/([\d.]+)/,bn:1,bv:2},
   {re:/\bVersion\/([\d.]+).*\b(Safari)\/[\d.]+/,bn:2,bv:1},
   {re:/\b(\S+)\/([\d.]+)$/,bn:1,bv:2}
  ];
  let rv;
  for(const bre of browsers) {
   let m = navigator.userAgent.match(bre.re);
   if(m && m.length>=3) {
    rv = {
     name: m[bre.bn],
     version: m[bre.bv],
     major: parseInt(m[bre.bv])
    };
    break;
   }
  }
  if(!rv) rv = {
   name: navigator.appName,
   version: navigator.appVersion,
   major: undefined
  };
  rv.support = {
   call: rv.major >= {
    // call is supported in these browser versions:
    Edge: 17, Firefox: 60, Chrome: 49, Safari: 11
   }[rv.name],
   sharing: rv.major >= {
    // this is where we support sharing:
    Chrome: 49
   }[rv.name]
  };
  return rv;
 })(),

 query: new URLSearchParams(window.location.search),

 copy_to_clipboard: function copy_to_clipboard(text) {
  // TODO: this is obviously a copypaste and needs a bit of review…
  if (window.clipboardData && window.clipboardData.setData) {
   // IE specific code path to prevent textarea being shown while dialog is visible
   return window.clipboardData.setData("Text", text); 
  } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
   var textarea = document.createElement("textarea");
   textarea.textContent = text;
   textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in MS Edge.
   document.body.appendChild(textarea);
   textarea.select();
   try {
       return document.execCommand("copy");  // Security exception may be thrown by some browsers.
   } catch (ex) {
       L.warn({err:ex},"failed to copy to the clipboard");
       return false;
   } finally {
       document.body.removeChild(textarea);
   }
  }
 },
 emos: [
  { "re": /\(y\)/gi, "icon": "👍", "text": "(y)" },
  { "re": /\(n\)/gi, "icon": "👎", "text": "(n)" },
  { "re": /:\)/gi, "icon": "🙂", "text": ":)" },
  { "re": /:\(/gi, "icon": "🙁", "text": ":(" },
  { "re": /\(laughing\)/gi, "icon": "😄", "text": "(laughing)"},
  { "re": /\(grin\)/gi, "icon": "😆", "text": "(grin)"},
  { "re": /:\p/gi, "icon": "😛", "text": ":("},
  { "re": /;\)/gi, "icon": "😉", "text": ";)"},
  { "re": /\(cool\)/gi, "icon": "😎", "text": "(cool)"},
  { "re": /\(love\)/gi, "icon": "🥰", "text": "(love)" },
  { "re": /\(angry\)/gi, "icon": "😡", "text": "(angry)"},
  { "re": /\(cry\)/gi, "icon": "😭", "text": "(cry)" },
  { "re": /\(party\)/gi, "icon": "🥳", "text": "(party)" },
  { "re": /\(pray\)/gi, "icon": "🙏", "text": "(pray)" },
  { "re": /\(cactus\)/gi, "icon": "🌵", "text": "(cactus)"},
  { "re": /\(heart\)/gi, "icon": "❤️", "text": "(heart)"},
  { "re": /\(cake\)/gi, "icon": "🎂", "text": "(cake)"},
  { "re": /\(flower\)/gi, "icon": "🌻", "text": "(flower)"},
  { "re": /\(plane\)/gi, "icon": "✈️", "text": "(plane)"},
  { "re": /\(train\)/gi, "icon": "🚂", "text": "(train)"},
  { "re": /\(bus\)/gi, "icon": "🚌", "text": "(bus)"},
  { "re": /\(car\)/gi, "icon": "🚗", "text": "(car)"},
  { "re": /\(bike\)/gi, "icon": "🚴", "text": "(bike)"},
  { "re": /\(coffee\)/gi, "icon": "☕️", "text": "(coffee)"},
  { "re": /\(food\)/gi, "icon": "🍝", "text": "(food)" },
  { "re": /\(rain\)/gi, "icon": "🌧", "text": "(rain)"},
  { "re": /\(umbrella\)/gi, "icon": "☔️", "text": "(umbrella)"},
  { "re": /\(sun\)/gi, "icon": "🌞", "text": "(sun)"},
  { "re": /\(rocket\)/gi, "icon": "🚀", "text": "(rocket)"}
 ],
 decorate_text: function decorate_text(text) {
  // apply anchor tags for hyperlinks
  const regex = /((http|https|ftp):\/\/[\w?=&./-;#~%-]+(?![\w\s?&./;#~%"=-]*>))/g;
  text = text.replace(regex, "<a class='wtg-word-break' href='$1' target='_blank'>$1</a>");
  // apply emoticons
  for(var i in this.emos) {
   text = text.replace(this.emos[i].re, '<span class="material-icons wtg-emoticon">' + this.emos[i].icon + '</span>');
  }
  return text;
 },
 format_size_units: function(bytes, decimals=2) {
  if (bytes === 0) return '0 B';
  const k = 1000;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return (bytes / Math.pow(k, i)).toFixed(dm) + ' ' + sizes[i];
 },
 fmt: (function() {
  function v(x) {
   return (x===null || x===undefined) ? '' : (''+x);
  }
  return function(sf,d) {
   return ((''+sf)||'').replace(/\{([^}]+)\}/g, function(m,n) {
    switch(n.charAt(0)) {
     case '%': return encodeURIComponent(v(d[n.substr(1)]));
     case '&': return v(d[n.substr(1)]).replace(/&/g,'&amp;')
     .replace(/</g,'&gt;').replace(/>/g,'&lt;')
     .replace(/"/g,'&quot;');
     default: return v(d[n]);
    }
   });
  };
 })()
};

export let L = U.L;

export const UTIL= {
 get_endpoint : function() {
  var o = window.location.origin.split(':').splice(0,2).join(':'), p = +window.location.port;
  var host=o;
  host+=p?(":"+p):"";
  return host;
 },
 getAspectRatio: function (w, h) {
  function gcd (a, b) {
   return (b == 0) ? a : gcd (b, a%b);
  }
  var r = gcd (w, h);
  return (w/r) / (h/r);
 },
 getTimestamp: () => new Date().toTimeString().substr(0,5),
 setMediaBitrates: function(sdp) {
  return this.setMediaBitrate(this.setMediaBitrate(sdp, "video", 500), "audio", 50);
 },
 setMediaBitrate: function(sdp, media, bitrate) {
  var lines = sdp.split("\n");
  var line = -1;
  for (var i = 0; i<lines.length; i++) {
    if (lines[i].indexOf("m="+media) === 0) {
      line = i;
      break;
    }
  }
  if (line === -1) {
    //console.debug("Could not find the m line for", media);
    return sdp;
  }
  //console.debug("Found the m line for", media, "at line", line);
  // Pass the m line
  line++;
  // Skip i and c lines
  while(lines[line].indexOf("i=") === 0 || lines[line].indexOf("c=") === 0) {
    line++;
  }
  // If we're on a b line, replace it
  if (lines[line].indexOf("b") === 0) {
    //console.debug("Replaced b line at line", line);
    lines[line] = "b=AS:"+bitrate;
    return lines.join("\n");
  }
   // Add a new b line
  //console.debug("Adding new b line before line", line);
  var newLines = lines.slice(0, line);
  newLines.push("b=AS:"+bitrate);
  newLines = newLines.concat(lines.slice(line, lines.length));
  return newLines.join("\n");
 },
 get_stats:function(pc,cb) {
  const common = Object.assign({type:'audio_level',id:pc.id},pc.remote_stream&&{sid:pc.remote_stream.id});
  pc.getStats().then(res=>{
   var data=[];
   res.forEach(function(report) {
    if (report.type==='track'&&report.remoteSource==true&&report.kind==="audio")
     data.push(Object.assign(common,{p:100*report.audioLevel}));
   });
   cb(data);
  });
 },
 is_mobile: function() {
 return (navigator.userAgent.match(/Android/i)
  || navigator.userAgent.match(/webOS/i)
  || navigator.userAgent.match(/iPhone/i)
  || navigator.userAgent.match(/iPad/i)
  || navigator.userAgent.match(/iPod/i)
  || navigator.userAgent.match(/BlackBerry/i)
  || navigator.userAgent.match(/Windows Phone/i));
 }
};

import _PERSISTENCE from './persistence.js';
export const PERSISTENCE = _PERSISTENCE;
